class Perfil {
    constructor(id, nome,listaPrivilegios){
        this.id = id;
        this.nome = nome;
        this.listaPrivilegios = listaPrivilegios;
    }
}

export default Perfil;
